import * as Sentry from "@sentry/react";
import constant from "../Constant";
import { beforeSend, ignoreErrors } from "./sentryFilters";

const isDevelopment = process.env.REACT_APP_ENV === "dev";
const isProduction = process.env.REACT_APP_ENV
  ? process.env.REACT_APP_ENV === "prod"
  : import.meta.env.VITE_ENV === "prod";


export function initSentry() {
  if (!isDevelopment) {
    Sentry.init({
      dsn: constant.SENTRY_DNS,

      // This enables automatic instrumentation (highly recommended), but is not
      // necessary for purely manual usage
      integrations: [
        Sentry.browserTracingIntegration(),
        ...(isProduction ? [Sentry.replayIntegration()] : [])
      ],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 0.2,
      environment: isProduction ? "production" : "staging",
      release: process.env.REACT_APP_SENTRY_RELEASE,
      ignoreErrors,
      beforeSend,
      // This sets the sample rate to be 10%. You may want this to be 100% while
      // in development and sample at a lower rate in production
      replaysSessionSampleRate: 0.0,

      // If the entire session is not sampled, use the below sample rate to sample
      // sessions when an error occurs.
      replaysOnErrorSampleRate: 1.0,
    });
  }
}

export function logError(error, errorInfo = null) {
  if (!isDevelopment) {
    Sentry.withScope((scope) => {
      errorInfo && scope.setExtras(errorInfo);
      Sentry.captureException(error);
    });
  }
}
